import { render, staticRenderFns } from "./TextLabel.vue?vue&type=template&id=5c228e7a&scoped=true"
import script from "./TextLabel.vue?vue&type=script&lang=js"
export * from "./TextLabel.vue?vue&type=script&lang=js"
import style0 from "./TextLabel.vue?vue&type=style&index=0&id=5c228e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c228e7a",
  null
  
)

export default component.exports